import { takeLatest, put, all, delay } from 'redux-saga/effects';
import {
  GET_FROM_SUGGESTS,
  SEARCH_SUGGESTS,
  SEARCH_SUGGESTS_SUCCESS,
  GET_FROM_SUGGESTS_SUCCESS,
  CLEAR_SEARCH_SUGGESTS,
} from '../actions/suggest';
import { serializeSearchPersons } from '../serializers/search';
import { serializeMailBox, serializeMailBoxes } from '../serializers/mailBox';
import { safeApply, safeCall } from './errors';
import { fetchSearchSuggests } from './search';
import { fetchMailBoxes } from './mailbox';

const SEARCH_PAGE_SIZE = 20;

export function* searchSuggest({
  payload: { query, pageSize = SEARCH_PAGE_SIZE },
}) {
  if (query.length < 3) {
    yield put({ type: CLEAR_SEARCH_SUGGESTS });
    return;
  }

  const data = yield safeCall(fetchSearchSuggests, { query, pageSize });
  const { persons } = serializeSearchPersons(data);

  yield put({ payload: { persons }, type: SEARCH_SUGGESTS_SUCCESS });
}

export function* getFromSuggests() {
  yield delay(500);
  const data = yield safeCall(fetchMailBoxes);
  const { mailBoxes } = serializeMailBoxes(data);
  const defaultMailBox = serializeMailBox(data.default_value);

  yield put({
    payload: { mailBoxes, defaultMailBox },
    type: GET_FROM_SUGGESTS_SUCCESS,
  });
}

export default function* () {
  yield all([
    yield takeLatest(SEARCH_SUGGESTS, safeApply(searchSuggest)),
    yield takeLatest(GET_FROM_SUGGESTS, safeApply(getFromSuggests)),
  ]);
}
